import {useFlagVariation} from '@customink/signalmizely-react';
import {useMemo} from 'react';

export const useSignalmizelyFlagEnabled = (
  flagName: string,
  options: {attributes?: Record<string, string | number | boolean>} = {}
): boolean | undefined => {
  const {variation, isLoading} = useFlagVariation(flagName, options);
  return useMemo(() => {
    return isLoading ? undefined : variation === 'test';
  }, [variation, isLoading]);
};
